import GoTrue from 'gotrue-js'

const state = {
    darkmode: getSavedState('theme.darkmode')
}

function getSavedState(key) {
    return JSON.parse(window.localStorage.getItem(key))
}

export default state
